module.exports = __webpack_public_path__ + "img/banner_1.00e175a3.png";